import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../data.service';

/**
 *  ADMIN → KRÉTA → KRÉTA-ÁTVITEL ÁLLAPOTA (backend: kreta-atvitel.js).
 *
 *  A SULINFORM a KRÉTA melletti kiegészítő rendszer (Nkt. 57. § (6)): a kötelező adatok helye a
 *  KRÉTA. Ez a lap adatkörönként megmutatja, mi kerül át magától, mi marad KÉZI (a félévi / év
 *  végi jegy mindig), és az utolsó N nap kihagyott / hibás tételeit a szinkron naplóiból. Az
 *  önteszt 2026-11-02 óta külön lapon van (admin/kreta-onteszt). A KRÉTÁ-BA SEMMIT NEM ÍR.
 */
@Component({
  selector: 'app-admin-kreta-atvitel',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, RouterModule],
  templateUrl: './kreta-atvitel.component.html',
  styleUrls: ['./kreta-atvitel.component.scss'],
})
export class AdminKretaAtvitelComponent implements OnInit {
  intezmeny = '';
  napok = 30;
  readonly napValasztek = [7, 30, 90, 180];
  toltodik = false;
  hiba = '';
  adat: any = null;

  readonly modNev: Record<string, string> = {
    automatikus: 'Automatikus',
    kezi_inditas: 'Csak kézi indításra',
    kezi: 'Kézi – a KRÉTÁ-ban kell rögzíteni',
  };
  readonly allapotNev: Record<string, string> = {
    rendben: 'Rendben', figyelmeztetes: 'Figyelmeztetés', hiba: 'Hiba', nincs_adat: 'Nem ellenőrizhető',
  };

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    const si: any = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(si?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    await this.betolt();
  }

  async betolt() {
    if (!this.intezmeny) return;
    this.toltodik = !this.adat;
    this.hiba = '';
    try {
      this.adat = await firstValueFrom(this.http.get(`/api/kreta-atvitel/allapot/${this.intezmeny}?napok=${this.napok}`));
    } catch (e: any) {
      this.hiba = e?.error?.error || 'Az állapot nem tölthető be.';
    } finally {
      this.toltodik = false;
    }
  }

  /** A tétel-sor színe: hiba > kihagyva > rendben. */
  szin(a: any): string {
    if (a.mod === 'kezi') return 'warning';
    if ((a.hiba || 0) > 0) return 'danger';
    if ((a.kihagyva || 0) > 0 || (a.varakozik || 0) > 0) return 'warning';
    return 'success';
  }

  osszegzesSzin(o: string): string {
    return o === 'hiba' ? 'danger' : o === 'figyelmeztetes' ? 'warning' : o === 'rendben' ? 'success' : 'medium';
  }

  ido(v: any): string {
    if (!v) return '–';
    const d = new Date(v);
    return isNaN(d.getTime()) ? String(v) : d.toLocaleString('hu-HU', { dateStyle: 'short', timeStyle: 'short' });
  }
}
